var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProceed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65079 5.24076C4.35428 4.9866 3.93694 4.92832 3.58214 5.0915C3.22734 5.25469 3 5.60948 3 6.00001V18C3 18.3905 3.22734 18.7453 3.58214 18.9085C3.93694 19.0717 4.35428 19.0134 4.65079 18.7593L11.6508 12.7593C11.8724 12.5693 12 12.2919 12 12C12 11.7081 11.8724 11.4307 11.6508 11.2408L4.65079 5.24076ZM9.46341 12L5 15.8258V8.17423L9.46341 12ZM14.6508 5.24076C14.3543 4.9866 13.9369 4.92832 13.5821 5.0915C13.2273 5.25469 13 5.60948 13 6.00001V18C13 18.3905 13.2273 18.7453 13.5821 18.9085C13.9369 19.0717 14.3543 19.0134 14.6508 18.7593L21.6508 12.7593C21.8724 12.5693 22 12.2919 22 12C22 11.7081 21.8724 11.4307 21.6508 11.2408L14.6508 5.24076ZM19.4634 12L15 15.8258V8.17423L19.4634 12Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProceed);
export default __webpack_public_path__ + "static/media/proceed.cf012f6b6f5d382305a91cdfefc429a2.svg";
export { ForwardRef as ReactComponent };